export default "__VITE_ASSET__10XjgNu4__"